import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Star, FileText, Clock, Building2, CircleCheck } from "lucide-react";
import HeaderComponent from "components/card/HeaderComponent";
import {
    getTicketDetails,
    doTicketUpdate
} from "../../../../../../redux/ticket/ticketState";
import { API_URL } from "services/apiservice";
import AttachmentCard from "components/card/AttachmentCard";

const OpenMessageCard = ({ 
  message, 
  isStarred, 
  onToggleStar,
  getTicketDetails,
  recordData,
  doTicketUpdate
}) => {

  useEffect(() => {
    if (message?.tic_id) {
      getTicketDetails({
        tic_id: message.tic_id,
      });
    }
  }, [message?.tic_id]);

  useEffect(() => {
  }, [recordData]);

  if (!recordData) return null;

  const ticketData = recordData?.data;

  const handleMarkAsRead = (e) => {
    e.stopPropagation();
    if (message.tic_is_seen !== 1) {
      doTicketUpdate({
        tic_id: message.tic_id,
        tic_is_seen: 1,
      });
    }
  };

  return (
    <HeaderComponent
      title={ticketData?.tic_title}
      bgcolor="gradient light-indigo"
      cardBorder="ring-2 ring-blue-500"
      description={
        <div className="flex flex-col gap-1">
          <div className="inline-flex gap-1 items-center">
            <p>From:</p>
            <p className="text-sm font-medium">Hyvid {ticketData?.department}</p>
          </div>
          <div className="inline-flex gap-1 items-center">
            <p className={`text-[10px] status-indicator uppercase ${ticketData?.ticket_priority?.toLowerCase().replace(/\s+/g, "-")}`}>
              {ticketData?.ticket_priority} PRIORITY
            </p>
            <p className="text-xs inline-flex items-center gap-1">
              <Clock className="w-3 h-3" /> {ticketData?.created_date} at {ticketData?.created_time}
            </p>
          </div>
        </div>
      }
      icon={
        <span className="w-11 h-11 border-2 border-white flex items-center justify-center rounded-full bg-blue-500 text-white font-semibold">
          {ticketData?.department_initial}
        </span>
      }
      rightNav={
        <div className="flex gap-3">
          <button
            onClick={(e) => {
              e.stopPropagation();
              onToggleStar();
            }}
          >
            <Star className={`w-4 h-4 ${isStarred ? "fill-yellow-500 text-yellow-500" : "text-slate-700"}`} />
          </button>
          <button
            onClick={handleMarkAsRead}
            className="inline-flex items-center justify-center"
            title="Mark as read"
          >
            <CircleCheck className={`w-4 h-4 ${message?.tic_is_seen === 1 ? "text-blue-500" : "text-slate-700"}`} />
          </button>
        </div>
      }
    >
      <div className="text-sm whitespace-pre-line my-8 muted-text">
        {ticketData?.tic_message}
      </div>

      {ticketData?.attachment?.length > 0 && (
          <div className="space-y-2 sm:space-y-2.5">
              <div className="bg-slate-200 h-px w-full my-4"></div>

              <div>
                  <h4 className="font-semibold text-[12px] sm:text-[13px] text-slate-700 mb-2 flex items-center gap-2">
                      <FileText className="w-3 h-3" />
                      Attachments ({ticketData.attachment.length})
                  </h4>

                  <div className="space-y-2">
                      {ticketData.attachment.map((file) => (
                          <AttachmentCard
                              key={file.att_id}
                              attachment={{
                                  id: file.att_id,
                                  name: file.att_filename,
                              }}
                              onDownload={(file) => {
                                  window.open(
                                      `${API_URL}/download/attachment/${file.id}`,
                                      "_blank"
                                  );
                              }}
                              onView={(file) => {
                                  window.open(
                                      `${API_URL}/preview/attachment/${file.id}`,
                                      "_blank"
                                  );
                              }}
                          />
                      ))}
                  </div>
              </div>
          </div>
      )}

      <div className="mt-4 p-3 rounded-lg bg-gradient-to-br from-blue-50 to-indigo-50 border border-blue-200 dark:from-blue-900 dark:to-indigo-900">
        <div className="flex items-start gap-2">
          <Building2 className="w-3.5 h-3.5 text-blue-600 dark:text-blue-500" />
          <div>
            <p className="text-[11px] sm:text-[12px] text-blue-900 font-medium dark:text-blue-50">
              Official Communication from Hyvid
            </p>
            <p className="text-[10px] sm:text-[11px] text-blue-700 mt-0.5 dark:text-blue-200">
              This is a one-way communication channel. For inquiries, please contact your account manager or support team directly.
            </p>
          </div>
        </div>
      </div>
    </HeaderComponent>
  );
};
const mapStateToProps = (state) => ({
  userId: state.auth?.user?.id,
  recordData: state.ticket?.ticketDetails,
});

const mapDispatchToProps = (dispatch) => ({
  getTicketDetails: (data) => dispatch(getTicketDetails(data)),
  doTicketUpdate: (data) => dispatch(doTicketUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(OpenMessageCard);
